import {Component, Inject, Input, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-content-display-dialog',
  templateUrl: './content-display-dialog.component.html',
  styleUrls: [
    './content-display-dialog.component.scss',
  ],
  encapsulation: ViewEncapsulation.None
})
export class ContentDisplayDialogComponent {
  contentType: string;

  @Input() buttonText: string;
  @Input() displayText: string;
  @Input() displayHeading: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.buttonText = data.buttonText;
    this.displayText = data.message;
    this.displayHeading = data.heading;
    this.contentType = this.determineContentType(this.displayText);
  }

  // Info: BE doesn't return content therefore validated based on contend from FE side
  private determineContentType(text: string): string {
    try {
      JSON.parse(text);
      return 'json';
    } catch {
      return 'xml';
    }
  }
}
